import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueI18n from 'vue-i18n';
import { server } from './providers/http-service';
import bridge from './components/brideg.vue';
import track from './utils/track';
import './assets/text/text.css';
import enLocale from './lang/en';
import zhLocale from './lang/zh';
import tcLocale from './lang/tc';
import arLocale from './lang/ar';
import trLocale from './lang/tr';
import esLocale from './lang/es';
import ptLocale from './lang/pt';
import frLocale from './lang/fr';
import idLocale from './lang/id';
import msLocale from './lang/ms';
// import Vant from 'vant';
// import 'vant/lib/index.css';
// Vue.use(Vant);
import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})
const messages = {
  en: {
    ...enLocale,
  },
  ar: {
    ...arLocale,
  },
  zh: {
    ...zhLocale,
  },
  tc: {
    ...tcLocale,
  },
  tr: {
    ...trLocale,
  },
  es: {
    ...esLocale,
  },
  pt: {
    ...ptLocale,
  },
  fr: {
    ...frLocale,
  },
  id: {
    ...idLocale,
  },
  ms: {
    ...msLocale,
  },
};
Vue.prototype.$completes = bridge;
Vue.prototype.$track = track;
// Vue.prototype.$serviceIp = 'http://prod-node-ops-01/'; //正式服 vf5
// Vue.prototype.$serviceIp = 'http://dev.api.koudailive.com/';//测试服
Vue.prototype.$serviceIp = process.env.VUE_APP_BASE_URL;
// import $ from 'jquery'
Vue.use(VueI18n);

Vue.prototype.$server = server;

Vue.config.productionTip = false;


//弹出框禁止滑动
 
Vue.prototype.stopScroll = function () {
  var mo = function (e) { e.preventDefault() }
  document.body.style.overflow = 'hidden'
  document.addEventListener('touchmove', mo, false)// 禁止页面滑动
 }
 //弹出框可以滑动
 Vue.prototype.canScroll = function () {
  var mo = function (e) {
   e.preventDefault()
  }
  document.body.style.overflow = ''// 出现滚动条
  document.removeEventListener('touchmove', mo, false)
 }

const i18n = new VueI18n({
  locale: 'en', // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages,
});

(function() {
  let doc = document;
  let win = window;
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function() {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      if (clientWidth >= 640) {
        docEl.style.fontSize = '100px';
      } else {
        docEl.style.fontSize = 100 * (clientWidth / 640) + 'px';
      }
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})();

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
